import { config } from "@/config";
export const ConfiguracionAlmacenService = {
    async getAll() {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/ConfiguracionAlmacen`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new Error("Error al obtener las configuraciones de almacén");
        }
        const data = await response.json();
        return data.datos || data.data || data; // Handle depending on API response format (ApiResponse format used in backend)
    },
    async update(id, dto) {
        const token = localStorage.getItem("accessToken");
        const response = await fetch(`${config.API_URL}/api/ConfiguracionAlmacen/${id}`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(dto),
        });
        if (!response.ok) {
            throw new Error("Error al actualizar la configuración de almacén");
        }
        const data = await response.json();
        return data.exito || data.success || true;
    },
};
